import React from 'react';
import { ErrorPage } from '../../Pages';
import { User } from 'src/interfaces/iuser';
import { callApi } from 'src/core/callApi';

const logUICrashOnDB = () => {
  const trackBugsURL = 'https://iph0vhcscg.execute-api.us-east-2.amazonaws.com/default/trackBugs';

  const config = {
    queryParams: {
      bug: 'app-crash',
    },
  };

  callApi(trackBugsURL, config, true);
};

class ErrorBoundary extends React.Component<{ user?: User }, { hasError: Boolean }> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });

    try {
      if (window.location.hostname != 'localhost') {
        logUICrashOnDB();
      }
    } catch (e) {
      console.log('Exception catched in UI Health Monitoring code', e);
    }
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return <ErrorPage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
